import request, { postRequest } from '@/utils/request';
import { getHost, getWxCloudMallHost } from '@/utils/utils';

// 弹窗相关接口
export async function markAuthPop(data) {
  const host = await getHost('device');
  return postRequest(`${host}/v1/app/dialog/mark`, data);
}

// 获取产品页弹框内容
export async function getProductModalInfo(data) {
  const host = await getHost('device');
  return postRequest(`${host}/v1/app/dialog/content`, data);
}

// 获APP首页弹窗配置
export async function getPopupAdsConfig(data) {
  const host = await getHost('device');
  return postRequest(`${host}/v3/app/popupConfig/get`, data, { selfCase: true });
}

// 获取瓜分好友页面数据
export async function querySplitCashActData(data) {
  const host = await getHost('device');
  return postRequest(`${host}/v3/activity/invite/user/inviteRank`, data);
}

// 查询用户是否属于某个客群
export async function queryUserBelongGroup(data) {
  const host = await getHost('device');
  return postRequest(`${host}/v3/user/customergroup/belong`, data);
}

// 查询新人任务
export async function queryTaskInfo(data) {
  const host = await getHost('device');
  return postRequest(`${host}/v3/rightsLinkPage/queryTask`, data);
}

// X86增加预估带宽接口
export async function setBandWdith(data) {
  const host = await getHost('device');
  return postRequest(`${host}/v3/recruit/activity/sign_up`, data);
}

export async function getSignUpDetails(data) {
  const host = await getHost('device');
  return postRequest(`${host}/v3/recruit/activity/get_sign_up_details`, data);
}

export async function getActivityRankData() {
  const host = await getHost('device');
  return postRequest(`${host}/v3/recruit/activity/rank`);
}

export async function getActivityUserRankData() {
  const host = await getHost('device');
  return postRequest(`${host}/v3/recruit/reward/user-rank`);
}

export async function getActivityUserInfo(data) {
  const host = await getHost('device');
  return postRequest(`${host}/v3/recruit/activity/user_info`, data);
}

export async function getActivityCalendar(data) {
  const host = await getHost('device');
  return postRequest(`${host}/v3/recruit/activity/calendar`, data);
}

export async function validateDeviceStatus(data) {
  const wxCloudMallHost = await getWxCloudMallHost();
  return request(
    `${wxCloudMallHost}/wxcloud/wxcloud_official/api/outer/v2/wxcloud/sninfo/checkBlack?sn=${data}`
  );
}

export async function getYundouLotteryDetails(data) {
  const host = await getHost('device');
  return postRequest(`${host}/v3/wxcloud_activity/api/outer/cloudbean/bigturn_get_result`, data);
}

export async function bigturnLottery(data) {
  const host = await getHost('device');
  return postRequest(`${host}/v3/wxcloud_activity/api/outer/cloudbean/bigturn_lottery`, data);
}

// 获取9周年设备列表
export async function getAnniversaryDeviceList(data) {
  const host = await getHost('device');
  return postRequest(`${host}/v3/device/anniversary/activity/list`, data);
}

// 获取9周年设备详情
export async function getAnniversaryDeviceDetail(data) {
  const host = await getHost('device');
  return postRequest(`${host}/v3/device/anniversary/activity/detail`, data);
}

// 获取9周年设备日历数据
export async function getAnniversaryDeviceCalendar(data) {
  const host = await getHost('device');
  return postRequest(`${host}/v3/device/anniversary/activity/calendar`, data);
}

// 设置9周年领奖校验
export async function checkAnniversaryRewardAccount(data) {
  const host = await getHost('device');
  return postRequest(`${host}/v3/device/anniversary/activity/account/check`, data);
}

// 设置9周年活动奖励领取账号
export async function setAnniversaryRewardAccount(data) {
  const host = await getHost('device');
  return postRequest(`${host}/v3/device/anniversary/activity/account/set`, data, {
    selfCase: true,
  });
}

// 获取9周年活动奖励领取记录
export async function getAnniversaryDeviceRewardRecord(data) {
  const host = await getHost('device');
  return postRequest(`${host}/v3/device/anniversary/activity/account/record`, data);
}

// 接口文档：http://wiki.onething.net/pages/viewpage.action?pageId=203984920
// 迅雷会员活动查询
export async function getXunLeiVipActSummary(data) {
  const host = await getHost('device');
  return postRequest(`${host}/v3/xl-vip/users/activities/devices`, data);
}

// 查询迅雷会员活动奖励记录
export async function getXunLeiRewardRecord(data) {
  const host = await getHost('device');
  return postRequest(`${host}/v3/xl-vip/users/rewards`, data);
}

// 领取迅雷会员
export async function receiveXunLeiReward(data) {
  const host = await getHost('device');
  return postRequest(`${host}/v3/xl-vip/users/devices/rewards`, data);
}

// 查询迅雷设备详情
export async function getXunLeiActDeviceDetail(data) {
  const host = await getHost('device');
  return postRequest(`${host}/v3/xl-vip/users/activities/devices/details`, data);
}

// 查询迅雷会员活动日历
export async function getXunLeiActDeviceCalendar(data) {
  const host = await getHost('device');
  return postRequest(`${host}/v3/xl-vip/users/devices/calendars`, data);
}

// 邀请好友抽奖
// 获取邀请好友抽奖信息
export async function getInviteLotteryInfo(data) {
  const host = await getHost('device');
  return postRequest(`${host}/v3/wxcloud_activity/api/outer/lottery/received`, data);
}

// 获取邀请好友剩余抽奖次数
export async function getInviteLotteryLeftNum(data) {
  const host = await getHost('device');
  return postRequest(`${host}/v3/wxcloud_activity/api/outer/lottery/getcnt`, data);
}

// 抽奖
export async function inviteLottery(data) {
  const host = await getHost('device');
  return postRequest(`${host}/v3/wxcloud_activity/api/outer/lottery/issue`, data, {
    selfCase: true,
  });
}

// 获取邀请好友抽奖奖励
export async function getInviteLotteryReward(data) {
  const host = await getHost('device');
  return postRequest(`${host}/v3/wxcloud_activity/api/outer/lottery/result`, data);
}

// 分享好友任务成功
export async function shareInviteTaskSuccess(data) {
  const host = await getHost('device');
  return postRequest(`${host}/v3/wxcloud_activity/api/outer/lottery/share`, data);
}

// 报名召回活动
export async function signUpRecallAct(data) {
  const host = await getHost('device');
  return postRequest(`${host}/v3/activity/recall/signup`, data);
}

// 获取召回活动报名状态
export async function getRecallActSignUpInfo(data) {
  const host = await getHost('device');
  return postRequest(`${host}/v3/activity/recall/signupInfo`, data);
}

// 获取召回活动数据
export async function recallDeviceActData(data) {
  const host = await getHost('device');
  return postRequest(`${host}/v3/activity/reward/get`, data);
}

// 获取硬件召回活动奖励数据
export async function hardwareRecallActRewardData(data) {
  const host = await getHost('device');
  return postRequest(`${host}/v3/device/activity/recall/reward`, data);
}
